import React from 'react';

const DandelionBackground: React.FC = () => {
  const dandelionCount = 1;
  const rotationIncrement = 8;

  return (
    <>
      {Array.from({ length: dandelionCount }, (_, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: `translate(-50%, -50%) rotate(${index * rotationIncrement}deg)`,
            width: '120vw',
            height: '120vh',
            backgroundImage: 'url(/dandelion.svg)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            opacity: 0.25,
            zIndex: 1,
            pointerEvents: 'none',
            transformOrigin: 'center center',
            filter: 'sepia(30%) saturate(80%) hue-rotate(-10deg)'
          }}
        />
      ))}
    </>
  );
};

export default DandelionBackground;